import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Tooltip,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";

const PurchaseOrderSummaryList = ({ data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const dataArray = Array.isArray(data)
    ? data
    : data?.results || data?.data || [];

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const formatOnlyDate = (dateTimeString) => {
    if (!dateTimeString) return "N/A";
    const datePart = dateTimeString.split("T")[0];
    const [year, month, day] = datePart.split("-");
    return `${day}-${month}-${year}`;
  };

  if (!dataArray || dataArray.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: "center", bgcolor: "#f5f5f5", borderRadius: 1 }}>
        <Typography sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
          No Purchase Orders found
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: "48vh",
        overflow: "auto",
      }}
    >
      <Table
        stickyHeader
        size="small"
        sx={{
          minWidth: "max-content",
          "& td, & th": {
            borderBottom: "1px solid #ccc",
            whiteSpace: "nowrap",
          },
        }}
      >
        {/* ✅ Header same as Solist - silver/grey */}
        <TableHead
          sx={{
            "& th": {
              fontWeight: "bold",
              color: (theme) =>
                theme.palette.mode === "dark" ? "#2196f3" : "#333",
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "black" : "#f5f5f5",
            },
          }}
        >
          <TableRow
            sx={{
              backgroundColor: "#f5f5f5",
              "& th": {
                fontWeight: "bold",
                color: "#333",
                borderBottom: "1px solid #999",
                whiteSpace: "nowrap",
              },
            }}
          >
            <TableCell align="center">S.No.</TableCell>
            <TableCell
              sx={{
                position: "sticky",
                left: 0,
                minWidth: 120,
                backgroundColor: "#f5f5f5",
                zIndex: 3,
              }}
              align="center"
            >
              PO Number
            </TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="center">Supplier</TableCell>
            <TableCell align="center">Project</TableCell>
            <TableCell align="center">Billing Name</TableCell>
            <TableCell align="center">Billing GST</TableCell>
            <TableCell align="center">Contact</TableCell>
            <TableCell align="center">Items</TableCell>
            <TableCell align="center">Total Qty</TableCell>
            <TableCell align="center">Total Amount</TableCell>
            <TableCell align="center">Status</TableCell>
            {/* <TableCell align="center">Remarks</TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {dataArray.map((po, index) => {
            const defaultBg = index % 2 === 0 ? "#fafafa" : "#ffffff";
            const hoverBg = "#e3f2fd";
            const items = po.items || [];
            const totalQty = items.reduce(
              (sum, it) => sum + (parseFloat(it.quantity) || 0),
              0
            );
            const totalAmount = items.reduce(
              (sum, it) => sum + (parseFloat(it.amount) || 0),
              0
            );

            return (
              <TableRow
                hover
                key={po.po_id || index}
                sx={{
                  backgroundColor: defaultBg,
                  "&:hover": {
                    backgroundColor: hoverBg,
                    "& td": { backgroundColor: hoverBg },
                  },
                  "& td": {
                    paddingTop: "2px !important",
                    paddingBottom: "2px !important",
                    fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    minWidth: 120,
                    backgroundColor: defaultBg,
                    zIndex: 2,
                    fontWeight: 600,
                  }}
                  align="center"
                >
                  {po.po_number || ""}
                </TableCell>
                <TableCell align="center">
                  {formatOnlyDate(po.created_at)}
                </TableCell>
                <TableCell align="center">{po.supplier_name || ""}</TableCell>
                <TableCell align="center">{po.project_name || ""}</TableCell>
                <TableCell align="center">
                  <Tooltip title={po.billing_name || ""} arrow>
                    <span>{truncateText(po.billing_name, 20)}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center">{po.billing_gst || ""}</TableCell>
                <TableCell align="center">{po.billing_contact || ""}</TableCell>
                <TableCell align="center">{items.length}</TableCell>
                <TableCell align="center">
                  {totalQty.toLocaleString("en-IN")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {totalAmount.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={po.approval_status || "Pending"}
                    size="small"
                    color={
                      po.approval_status === "Approved"
                        ? "success"
                        : po.approval_status === "Rejected"
                          ? "error"
                          : "warning"
                    }
                    sx={{ fontSize: "0.65rem", height: 20 }}
                  />
                </TableCell>
                {/* <TableCell align="center">
                  <Tooltip title={po.remarks || ""} arrow>
                    <span>{truncateText(po.remarks, 15)}</span>
                  </Tooltip>
                </TableCell> */}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PurchaseOrderSummaryList;